export default __webpack_public_path__ + "static/media/a22.600e9f9f.jpg";